import { client } from "@services/config";
import { Sort } from "./common";
import { Direction } from "@gen/tsam/v1/page_pb";
import {
  Caisse,
  CaisseService,
  Field,
  ListResponse,
} from "@gen/caisse/v1/caisse_pb";

export async function getCaisses(
  page: number = 1,
  size: number = 10,
  sort?: Sort,
): Promise<ListResponse> {
  let field: Field;
  switch (sort?.field) {
    case "id":
      field = Field.ID;
      break;
    case "agencyId":
      field = Field.AGENCY;
      break;
    case "name":
      field = Field.NAME;
      break;
    default:
      field = Field.UNSPECIFIED;
      break;
  }

  let direction: Direction;
  switch (sort?.direction) {
    case "asc":
      direction = Direction.ASC;
      break;
    case "desc":
      direction = Direction.DESC;
      break;
    default:
      direction = Direction.UNSPECIFIED;
      break;
  }

  return await client(CaisseService).list({
    page: {
      page: page,
      size: size,
    },
    sort: {
      field: field,
      direction: direction,
    },
  });
}

export async function getCaisse(id: number): Promise<Caisse | undefined> {
  return (await client(CaisseService).get({ id })).caisse;
}

// the edit form clears number inputs to "", which an optional int32 rejects
const optionalNumber = (v: unknown) => (typeof v === "number" ? v : undefined);

export async function createCaisse(caisse: Caisse) {
  return await client(CaisseService).onboard({
    id: caisse.id,
    agencyId: caisse.agencyId,
    trainStationSearchRadiusKm: caisse.trainStationSearchRadiusKm,
    airportSearchRadiusKm: caisse.airportSearchRadiusKm,
    assistedTrainAgencyFeesEurCents: caisse.assistedTrainAgencyFeesEurCents,
    assistedPlaneAgencyFeesEurCents: caisse.assistedPlaneAgencyFeesEurCents,
    assistedAgencyFeesVatPercent: optionalNumber(
      caisse.assistedAgencyFeesVatPercent,
    ),
  });
}

export async function updateCaisse(caisse: Caisse) {
  return await client(CaisseService).update({
    id: caisse.id,
    agencyId: caisse.agencyId,
    trainStationSearchRadiusKm: caisse.trainStationSearchRadiusKm,
    airportSearchRadiusKm: caisse.airportSearchRadiusKm,
    assistedTrainAgencyFeesEurCents: caisse.assistedTrainAgencyFeesEurCents,
    assistedPlaneAgencyFeesEurCents: caisse.assistedPlaneAgencyFeesEurCents,
    assistedAgencyFeesVatPercent: optionalNumber(
      caisse.assistedAgencyFeesVatPercent,
    ),
  });
}

export async function getCaisseIds() {
  return await client(CaisseService).listIdentities({});
}

export async function getAgencyInfo(caisseId: number) {
  return await client(CaisseService).getAgencyInfo({ id: caisseId });
}
